<template>
  <v-dialog :value="value" @input="handleDialogInput" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ routemap.name }}
      </v-card-title>

      <v-card-text>
        <ErrorMessages :errorMessages="localErrorMessages" />

        {{ $t("MATERIAL") }}
        <select
          v-model="form.routeMapCostStandardId"
          type="text"
          class="form-control"
        >
          <option disabled v-bind:value="0">{{ $t("CHOOSE") }}</option>
          <template v-for="cost in routemap.costStandards">
            <option
              v-if="cost.type != $t('MEDICINAL_PRODUCT')"
              v-bind:key="cost.id"
              v-bind:value="cost.id"
            >
              {{ cost.type }} {{ cost.name }} ({{ cost.batch }})
            </option>
          </template>
        </select>

        <template>
          {{ $t("NUMBER_OF_SCRAP_MATERIALS") }}
          <input
            type="number"
            min="1"
            v-model="form.quantity"
            class="form-control"
          />
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-on:click="handleSaveClicked">
          <span class="btn btn-primary btn-block">
            {{ $t("SAVE") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessages from "@/components/ErrorMessages";

export default {
  components: {
    ErrorMessages
  },

  props: {
    routemap: {
      required: true,
      type: Object
    },

    value: {
      required: true,
      type: Boolean
    },

    errorMessages: {
      default: () => {}
    }
  },

  data() {
    return {
      form: {
        routeMapCostStandardId: 0,
        quantity: 1
      },
      localErrorMessages: {}
    };
  },

  watch: {
    value() {
      this.clearForm();
    },

    errorMessages() {
      this.localErrorMessages = this.errorMessages;
    }
  },

  methods: {
    handleSaveClicked() {
      if (this.form.routeMapCostStandardId < 1) {
        this.localErrorMessages = {
          0: [this.$t("PLEASE_CHOOSE_MATERIAL")]
        };

        return;
      }

      if (this.form.quantity < 1) {
        this.localErrorMessages = {
          0: [this.$t("THE_NUMBER_OF_SCRAP_MATERIALS_MUST_BE_AT_LEAST_1")]
        };

        return;
      }

      this.$emit("save-clicked", this.form);
    },

    handleDialogInput(value) {
      this.clearForm();

      this.$emit("input", value);
    },

    clearForm() {
      this.form = {
        routeMapCostStandardId: 0,
        quantity: 1
      };

      this.localErrorMessages = {};
    }
  }
};
</script>
